import React from 'react';
import PropTypes from 'prop-types';
import Filter from './Filter';
import SortComponent from './Sort';
import SearchComponent from './Search';

import style from './index.scss';

export const SearchSortAndFilter = (props) => {
  const {
    widgetItemOperations,
    hasFilter,
    hasSort,
    hasSearch,
    applyFilterHandler,
    filters,
    alertLevels,
    moduleType = '',
    sourceIds = '27,28'
  } = props;

  // FIN-6612: Custom search options for TS-IAD module
  // TS-IAD needs Transaction ID and Party ID search options
  const filteredWidgetItemOperations = React.useMemo(() => {
    if (
      moduleType === '9' &&
      widgetItemOperations?.data?.widgetItems?.length > 0
    ) {
      // For TS-IAD: Remove partyName but keep partyId, and add transactionId
      const filteredItems = widgetItemOperations.data.widgetItems.map(
        (widget) => {
          // Filter out partyName (not applicable to TS-IAD)
          const filteredOps = widget.itemsOperations.filter(
            (item) => !['partyName'].includes(item.itemName)
          );

          // Add transactionId if not already present
          const hasTransactionId = filteredOps.some(
            (item) => item.itemName === 'transactionId'
          );
          if (!hasTransactionId) {
            filteredOps.push({
              itemName: 'transactionId',
              itemLabel: 'Transaction ID',
              isSearchable: true,
              isFilterable: false,
              isSortable: false,
              dataType: 'STRING'
            });
          }

          // Add partyId if not already present (for Party ID search)
          const hasPartyId = filteredOps.some(
            (item) => item.itemName === 'partyId'
          );
          if (!hasPartyId) {
            filteredOps.push({
              itemName: 'partyId',
              itemLabel: 'Party ID',
              isSearchable: true,
              isFilterable: false,
              isSortable: false,
              dataType: 'STRING'
            });
          }

          return {
            ...widget,
            itemsOperations: filteredOps
          };
        }
      );

      return {
        ...widgetItemOperations,
        data: {
          ...widgetItemOperations.data,
          widgetItems: filteredItems
        }
      };
    }

    return widgetItemOperations;
  }, [moduleType, widgetItemOperations]);

  return (
    <div className={style.flexWrapper}>
      <div className={style.filterSortWrapper}>
        {hasFilter && (
          <Filter
            GS={widgetItemOperations}
            applyFilterHandler={applyFilterHandler}
            filters={filters}
            alertLevels={alertLevels}
            sourceIds={sourceIds}
          />
        )}
        {hasSort && <SortComponent {...props} />}
      </div>
      {hasSearch && (
        <SearchComponent
          {...props}
          widgetItemOperations={filteredWidgetItemOperations}
        />
      )}
    </div>
  );
};

SearchSortAndFilter.defaultProps = {
  hasSearch: true,
  hasSort: true,
  hasFilter: true,
  applyFilterHandler: null,
  widgetItemOperations: {},
  alertLevels: []
};

SearchSortAndFilter.propTypes = {
  hasSearch: PropTypes.bool,
  hasSort: PropTypes.bool,
  hasFilter: PropTypes.bool,
  applyFilterHandler: PropTypes.func.isRequired,
  widgetItemOperations: PropTypes.object.isRequired,
  filters: PropTypes.object,
  alertLevels: PropTypes.array.isRequired,
  moduleType: PropTypes.string,
  sourceIds: PropTypes.string
};

export default SearchSortAndFilter;
